// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__27P3V","description":"PatientConsentPreview_description__DNIEa"};